import { Locale } from 'vant'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import esES from 'vant/lib/locale/lang/es-ES'

export default function locales(a) {
  if (a == 'es') {
    Locale.use('es', esES)
  } else if (a == 'zh') {
    Locale.use('zh', zhCN)
  }
}
